module.exports = __webpack_public_path__ + "assets/img/xiazai.f3b8cb11.png";